import { createAsyncThunk } from "@reduxjs/toolkit";
import { blockUnblockedUserAPI, DeleteGroupReportAPI, getAllGroupReportsAPI, sendWarningToUserEndPointURL } from "../../routes/apiEndPoints";
import { API_REQUEST } from ".";



// export const fetchAllGroups = createAsyncThunk("Get-all-groups",async () => {
//     try {
//       const response = await API_REQUEST({ 
//         url: getAllFirebaseGroupAPI,
//         method: "GET",
//       })
//       return response.data;      
//     } catch (error) {}
//   });


//  Get-all-report-group
export const fetchGroupReport = createAsyncThunk("Get-all-report-group", async () => {
  try {
    const response = await API_REQUEST({
      url: getAllGroupReportsAPI,
      method: "GET"
    })
    return response;
  } catch (error) { }
})


//  delete-group-report
export const deleteGroupReport = createAsyncThunk(
  "delete-group-report",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: DeleteGroupReportAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const warnToReportedGroup = createAsyncThunk(
  "Warn-Reported-group",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: sendWarningToUserEndPointURL,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const warnToDeleteGroup = createAsyncThunk(
  "Delete-Reported-group",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: sendWarningToUserEndPointURL,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const blockUnblockedGroupAdmin = createAsyncThunk(
  "Blocked-Unblocked-Group-Admin",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: blockUnblockedUserAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);